import { useState } from "react";
import { ExpertApplication } from "@/types/admin";

export function useExpertApplicationsState() {
  const [selectedApplication, setSelectedApplication] = useState<ExpertApplication | null>(null);
  const [adminNotes, setAdminNotes] = useState("");
  const [activeTab, setActiveTab] = useState("pending");

  const handleSelectApplication = (application: ExpertApplication) => {
    // console.log("📋 Selected application:", application.id, "Status:", application.status);
    setSelectedApplication(application);
  };

  const onCloseDetails = () => {
    setSelectedApplication(null);
    setAdminNotes("");
  };

  return {
    selectedApplication,
    adminNotes,
    activeTab,
    setAdminNotes,
    setActiveTab,
    handleSelectApplication,
    onCloseDetails
  };
}
